'use client';

import spTracker from '@smartproxy/sp-tracker-js';
import { useEffect } from 'react';

import { isProd } from '@/constant/env';
import { getCookie, setCookie } from '@/utils/cookies';

if (typeof window !== 'undefined') {
  const bootstrapData = getCookie('bootstrapExperiments') || ({} as any);

  spTracker.init({
    project: 'web',
    isProduction: isProd,
    options: {
      bootstrap: bootstrapData,
      api_host: '/ph', // Override api_host to use our own proxy
    },
    enablement: {
      isPostHogEnabled: true,
    },
  });
}

const preloadBootstrapFlags = async () => {
  const bootstrapCookie = getCookie('bootstrapExperiments');
  if (bootstrapCookie) {
    return;
  }
  const item = localStorage.getItem(
    `ph_${process.env.NEXT_PUBLIC_POSTHOG_API_KEY}_posthog`
  ) as any;
  const flags = JSON.parse(item)?.['$enabled_feature_flags'];
  const experiments = Object.keys(flags).reduce((acc, key) => {
    if (key.startsWith('experiment')) {
      acc[key] = flags[key];
    }
    return acc;
  }, {} as Record<string, string>);
  setCookie({
    name: 'bootstrapExperiments',
    value: JSON.stringify({ featureFlags: experiments }),
  });
};

export function PHProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    preloadBootstrapFlags();
  }, []);
  return <>{children}</>;
}
